import { render, staticRenderFns } from "./KiosksChangeDeviceDialog.vue?vue&type=template&id=8b52c6d2"
import script from "./KiosksChangeDeviceDialog.vue?vue&type=script&lang=js"
export * from "./KiosksChangeDeviceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports